import { apiSlice } from "../../app/api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCreators: builder.mutation({
      query: (creadentials) => ({
        url: "/creator/getCreators",
        method: "GET",
      }),
    }),
    sendProposal: builder.mutation({
      query: (id) => ({
        url: "/sponser/sendProposal",
        method: "POST",
        body: { _id: id },
      }),
    }),
    getSponser: builder.mutation({
      query: (sponserId) => ({
        url: `/sponser/getSponser/${sponserId}`,
        method: "GET",
      }),
    }),
    updateSponser: builder.mutation({
      query: ({ credentials, id }: { credentials: any; id: string }) => ({
        url: `/sponser/updateSponser/${id}`,
        method: "PUT",
        body: {
          ...credentials,
          address: credentials?.address1 + ":" + credentials?.address2,
          contact: Number(credentials?.contact),
        },
      }),
    }),
    getFeeds: builder.mutation({
      query: ({ sponserId }) => ({
        url: `/sponser/getFeeds/${sponserId}`,
        method: "GET",
      }),
    }),
    getEvents: builder.mutation({
      query: (sponserId) => ({
        url: `/sponser/getEvents/${sponserId}`,
        method: "GET",
      }),
    }),
    getDashboard: builder.mutation({
      query: ({ sponserId }) => ({
        url: `/sponser/dashboard/${sponserId}`,
        method: "GET",
      }),
    }),
    updateStatus: builder.mutation({
      query: ({ feedId, status, sponserId, creatorId }) => ({
        url: `/sponser/updateStatus`,
        method: "POST",
        body: {
          status: status,
          sponserId: sponserId,
          creatorId: creatorId,
          feedId: feedId,
        },
      }),
    }),
    clearNotification: builder.mutation({
      query: ({ notificationId, sponserId }) => ({
        url: `/sponser/clearNotification`,
        method: "POST",
        body: { notificationId, sponserId },
      }),
    }),
    getPayments: builder.mutation({
      query: ({ sponserId }) => ({
        url: `/sponser/getPayments/${sponserId}`,
        method: "GET",
      }),
    }),
    initializeRazorpay: builder.mutation({
      query: ({ sponserId, paymentId }) => ({
        url: `/razorpay/${sponserId}`,
        method: "POST",
        body: { paymentId },
      }),
    }),
    recordPayment: builder.mutation({
      query: ({
        razorpay_payment_id,
        razorpay_order_id,
        razorpay_signature,
        sponserId,
        paymentId,
        orderId,
      }) => ({
        url: `/addPayment/`,
        method: "POST",
        body: {
          razorpay_payment_id,
          razorpay_order_id,
          razorpay_signature,
          sponserId,
          paymentId,
          orderId,
        },
      }),
    }),
    sendOTP: builder.mutation({
      query: ({ email }) => ({
        url: `/sendOTP`,
        method: "POST",
        body: { email },
      }),
    }),
    verifyOTP: builder.mutation({
      query: ({ otp, hash, email }) => ({
        url: `/verifyOTP`,
        method: "POST",
        body: { otp, hash, email },
      }),
    }),
    forgotPassword: builder.mutation({
      query: ({ otp, hash, email, password }) => ({
        url: `/sponser/forgotPassword`,
        method: "POST",
        body: { email, password, otp, hash },
      }),
    }),
    addLandingPage: builder.mutation({
      query: ({ values, sponserId }) => ({
        url: `/sponser/addLandingPage`,
        method: "POST",
        body: { ...values, sponserId },
      }),
    }),
    getLandingPages: builder.mutation({
      query: ({ sponserId }) => ({
        url: `/sponser/getLandingPages/${sponserId}`,
        method: "GET",
      }),
    }),
    updateLandingPageStatus: builder.mutation({
      query: ({ sponserId, status, landingPageId }) => ({
        url: `/sponser/updateLandingPageStatus/${sponserId}`,
        method: "POST",
        body: { status, landingPageId },
      }),
    }),
    getProducts: builder.mutation({
      query: ({ sponserId, landingPageId }) => ({
        url: `/sponser/getProducts/${sponserId}/${landingPageId}`,
        method: "GET",
      }),
    }),
    removeLandingPage: builder.mutation({
      query: ({ sponserId, landingPageId }) => ({
        url: `/sponser/removeLandingPage/${sponserId}/${landingPageId}`,
        method: "GET",
      }),
    }),
    getLandingPage: builder.mutation({
      query: ({ sponserId, landingPageId }) => ({
        url: `/sponser/getLandingPage/${sponserId}/${landingPageId}`,
        method: "GET",
      }),
    }),
    initRazorPayForUser: builder.mutation({
      query: ({ sponserId, landingPageId, orderId }) => ({
        url: `/razorpay-user/${sponserId}`,
        method: "POST",
        body: { landingPageId, orderId },
      }),
    }),
    addOrder: builder.mutation({
      query: ({
        sponserId,
        landingPageId,
        products,
        firstName,
        lastName,
        address1,
        address2,
        houseOrFlatNo,
        PINCode,
        email,
        contact,
      }) => ({
        url: `/sponser/addOrder/${sponserId}`,
        method: "POST",
        body: {
          landingPageId,
          products,
          firstName,
          lastName,
          address1,
          address2,
          houseOrFlatNo,
          PINCode,
          email,
          contact,
        },
      }),
    }),
    getOrders: builder.mutation({
      query: ({ sponserId }) => ({
        url: `sponser/orders/${sponserId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetOrdersMutation,
  useAddOrderMutation,
  useInitRazorPayForUserMutation,
  useGetLandingPageMutation,
  useRemoveLandingPageMutation,
  useGetProductsMutation,
  useUpdateLandingPageStatusMutation,
  useGetLandingPagesMutation,
  useAddLandingPageMutation,
  useForgotPasswordMutation,
  useVerifyOTPMutation,
  useSendOTPMutation,
  useRecordPaymentMutation,
  useInitializeRazorpayMutation,
  useGetPaymentsMutation,
  useClearNotificationMutation,
  useUpdateStatusMutation,
  useGetDashboardMutation,
  useGetEventsMutation,
  useGetFeedsMutation,
  useUpdateSponserMutation,
  useGetCreatorsMutation,
  useSendProposalMutation,
  useGetSponserMutation,
} = authApiSlice;
